











import { Vue, Component } from 'vue-property-decorator';
import Conversor from '@/pantallas/Importar/Conversor/Conversor.vue';

@Component({
  components: { Conversor },
})
export default class ConversorPantalla extends Vue {
  tabModel: string = "0"
}
